import { useState } from "react";
import { useTranslation } from 'react-i18next';
import { useNumberFormat } from '../../hooks/useLanguageDetection';
import styles from "./FeedPost.module.css";
import BlockedScrollPopup from "../ChatComponents/BlockedScrollPopup";

import likeIcon from "../../assets/feed/coracao.svg";
import commentIcon from "../../assets/feed/comentario.svg";
import sendIcon from "../../assets/feed/enviar.svg";
import saveIcon from "../../assets/feed/salvar.svg";

export default function FeedPost({ username, avatar, likes, comments, time, blurLevel = 0, location, description, postImage, imageBlur, avatarBlur }) {
  const { t } = useTranslation();
  const baseFormatNumber = useNumberFormat();
  const [showPopup, setShowPopup] = useState(false);

  const formatNumber = (n) => {
    if (n >= 1000000) {
      const val = (n / 1000000).toFixed(1).replace(".", ",");
      return `${val} mi`;
    }
    if (n >= 1000) {
      const val = (n / 1000).toFixed(n >= 10000 ? 1 : 0).replace(".", ",");
      return `${val} mil`;
    }
    return baseFormatNumber(n);
  };

  const handleBlocked = () => setShowPopup(true);

  const blur = Math.max(0, (blurLevel - 2) * 1.5);
  const postStyle = blur > 0 ? { filter: `blur(${blur}px)` } : undefined;

  const finalAvatarBlur = avatarBlur !== undefined ? avatarBlur : 5;
  const avatarStyle = { filter: `blur(${finalAvatarBlur}px)` };

  const finalImageBlur = imageBlur !== undefined ? imageBlur : 30;
  const isRestricted = finalImageBlur > 0;

  return (
    <>
      <article className={styles.feedPost} style={postStyle}>

        {/* HEADER */}
        <header className={styles.postHeader}>
          <div className={styles.postUser}>
            <div className={styles.postAvatarWrapper}>
              <img src={avatar} alt="" className={styles.postAvatar} style={avatarStyle} />
            </div>
            <div className={styles.postUserInfo}>
              <span className={styles.postUsername}>{username}</span>
              {location && <span className={styles.postLocation}>{location}</span>}
            </div>
          </div>
          <button className={styles.postMenu} onClick={handleBlocked}>•••</button>
        </header>

        {/* IMAGEM */}
        <div className={styles.postImageContainer} onClick={isRestricted ? handleBlocked : undefined}>
          <img
            src={postImage || avatar}
            alt=""
            className={styles.postImage}
            style={{
              filter: isRestricted ? `blur(${finalImageBlur}px)` : 'none',
              transform: isRestricted ? "scale(1.15)" : "scale(1)",
            }}
          />
          {isRestricted && (
            <div className={styles.postRestricted}>
              <svg
                className={styles.restrictedIcon}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.6"
                  d="M16.5 10.5V8a4.5 4.5 0 10-9 0v2.5M9 10.5h6a3 3 0 013 3v4.5a3 3 0 01-3 3H9a3 3 0 01-3-3v-4.5a3 3 0 013-3z"
                />
              </svg>
              <p className={styles.restrictedTitle}>Conteúdo restrito</p>
            </div>
          )}
        </div>

        {/* AÇÕES */}
        <div className={styles.postActions}>
          <div className={styles.postActionsLeft}>
            <button className={styles.actionBtn} onClick={handleBlocked}>
              <img src={likeIcon} alt={t('common.like')} />
            </button>
            <button className={styles.actionBtn} onClick={handleBlocked}>
              <img src={commentIcon} alt={t('common.comment')} />
            </button>
            <button className={styles.actionBtn} onClick={handleBlocked}>
              <img src={sendIcon} alt={t('common.send')} />
            </button>
          </div>
          <button className={styles.actionBtn} onClick={handleBlocked}>
            <img src={saveIcon} alt="Salvar" />
          </button>
        </div>

        {/* CURTIDAS */}
        <div className={styles.postLikes} onClick={handleBlocked}>
          {formatNumber(likes)} curtidas
        </div>

        {/* DESCRIÇÃO */}
        {description && (
          <div className={styles.postDescription}>
            <span className={styles.postDescriptionUser}>{username}</span>
            <span className={styles.postDescriptionText}>{description}</span>
          </div>
        )}

        {/* COMENTÁRIOS */}
        {comments > 0 && (
          <div className={styles.postCommentsLink} onClick={handleBlocked}>
            Ver todos os {formatNumber(comments)} comentários
          </div>
        )}

        {/* DATA */}
        <div className={styles.postTime}>{time}</div>

      </article>

      <BlockedScrollPopup
        show={showPopup}
        onClose={() => setShowPopup(false)}
        title="🔒 Conteúdo bloqueado"
        description="Seja um membro VIP do Revelainsta.ai para interagir com as publicações"
      />
    </>
  );
}
